"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLoginInfo = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'page-header-user-login-info';
class UserLoginInfo extends react_1.default.PureComponent {
    render() {
        const { modificators, userName, } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__avatar` },
                react_1.default.createElement(Icon_1.Icon, { name: 'user-circle' })),
            react_1.default.createElement("div", { className: `${className}__content` },
                react_1.default.createElement("div", { className: `${className}__label` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserLoginInfo/AuthorizedAs:text', defaultMessage: 'authorized as' })),
                react_1.default.createElement("div", { className: `${className}__name` }, userName))));
    }
}
exports.UserLoginInfo = UserLoginInfo;
UserLoginInfo.defaultProps = {
    userName: 'Guest',
};
//# sourceMappingURL=index.js.map